
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import badEmails from 'personal-email-domains'
import md5 from 'md5'
import getInitials from '@segment/get-initials'
import Avatar from './Avatar'

class Gravatar extends Component {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    // TODO: move to constructor
    let shouldHideImage = false

    const { email, type, size, color, name } = this.props
    const domain = email ? email.split('@')[1] : null
    const company = type === 'company'
    const url = company
      ? `https://logo.clearbit.com/${domain}?format=png&size=${size * 2}`
      : `https://secure.gravatar.com/avatar/${email && md5(email)}.jpg?s=${size * 2}&d=blank`

    if (company) {
      shouldHideImage = domain in badEmails || !email
    }

    if (!company && !email) {
      shouldHideImage = true
    }

    return (
      <Avatar
        color={color}
        size={size}
        url={url}
        initials={getInitials(name)}
        shouldHideImage={shouldHideImage} />
    )
  }
}

Gravatar.displayName = 'Gravatar'

Gravatar.defaultProps = {
  size: 40,
  color: 'green'
}

Gravatar.propTypes = {
  email: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  name: PropTypes.string
}

export default Gravatar



// WEBPACK FOOTER //
// ./ui/Gravatar.js